import statusStyles from "../../styles/UI/statusIcon.module.css";
import { PondooJobStatus } from "../../types/ganttChart";

// Todo: move out of component and pass color
const CirclularStatusIcon = ({ status }: { status: PondooJobStatus }) => {
  const getStatusColorClass = () => {
    switch (status) {
      case (status = "Completed"):
        return statusStyles.circleGreen;
      case (status = "Failed"):
        return statusStyles.circleRed;
      case (status = "MISSING"):
        return statusStyles.circleRed;
      case (status = "Aborted"):
        return statusStyles.circleRed;
      case (status = "NotScheduled"):
        return statusStyles.circlePurple;
      case (status = "Scheduled"):
        return statusStyles.circlePurple;
      case (status = "Running"):
        return statusStyles.circlePurple;
      case (status = "OUTDATED"):
        return statusStyles.circleYellow;
    }
  };

  return (
    <div className={`${statusStyles.circle} ${getStatusColorClass()}`}></div>
  );
};

export default CirclularStatusIcon;
